export enum QuanLyQuyHoachActionType {
  QuanLyQuyHoach = 'QLQH_QuanLyQuyHoach',

  PhuHopQuyHoach_objectId='PhuHopQuyHoach_objectId',
  PhuHopQuyHoach_dienTichDuAn='PhuHopQuyHoach_dienTichDuAn',
  PhuHopQuyHoach_dienTichSuDungDats='PhuHopQuyHoach_dienTichSuDungDats',
  // PhuHopQuyHoach_color='PhuHopQuyHoach_Color',

  GetListYKDA = 'QLQH_GetListYKDA',
  GetListCBDA = 'QLQH_GetListCBDA',
  GetListNDGopYYK = 'QLQH_GetListNDGopYYK',
  GetListNDGopYCB = 'QLQH_GetListNDGopYCB',
  tabIndexYKien = 'QLQH_tabIndexYKien',
  deleteYkienGopY = 'QLQH_deleteYkienGopY',
  LuuTru_HienThi = 'QLQH_LuuTru_HienThi',
  LuuTru_ChonFile = 'QLQH_LuuTru_ChonFile',
  LuuTru_SetFiles = 'QLQH_LuuTru_SetFiles',
  LuuTru_SetFileResponses = 'QLQH_LuuTru_SetFileResponses',
  GetDataCount = 'GetDataCount',
  GetDataCountGopY = 'GetDataCountGopY',
  GetList = 'GetList',
  GetListGopY = 'GetListGopY'
}